/**
 * Throws an error if the condition is not met.
 * This is stripped from production builds.
 */
export function assert(message: string, condition?: unknown): asserts condition {
  if (process.env.NODE_ENV !== 'production') {
    if (condition) {
      return;
    }

    throw new Error(`Assertion Failed: ${message}`);
  }
}

/**
 * Logs a message to the console.
 * This is stripped from production builds.
 */
export function debug(message: string): void {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console -- That's a debugging message
    console.debug(`DEBUG: ${message}`);
  }
}
